class PannerNode extends Weaver.Node

  @className = 'Panner'

  constructor: (id) ->
    super(id)

  create: (name = "New Panner", panningModel = 'HRTF', distanceModel = 'inverse', refDistance = 1, maxDistance = 10000, rolloffFactor = 1, coneInnerAngle = 360, coneOuterAngle = 0, coneOuterGain = 0, orientationX = 1, orientationY = 0, orientationZ = 0) ->
    type = await Weaver.Node.firstOrCreate('Panner')
    @set('name', name)
    @set('panningModel', panningModel)
    @set('distanceModel', distanceModel)
    @set('refDistance', refDistance)
    @set('maxDistance', maxDistance)
    @set('rolloffFactor', rolloffFactor)
    @set('coneInnerAngle', coneInnerAngle)
    @set('coneOuterAngle', coneOuterAngle)
    @set('coneOuterGain', coneOuterGain)
    @set('orientationX', orientationX)
    @set('orientationY', orientationY)
    @set('orientationZ', orientationZ)
    @relation('type').add(type)
    @save()

export default PannerNode
